import { Badge } from 'react-bootstrap';
import { formatDataHora } from '../../utils/dateUtils';
import { FormattedIntegration } from '../../utils/formatters/integracaoExternaFormatter';

interface IntegracaoExternaGridRowProps {
  integration: FormattedIntegration;
  onClick: () => void;
}

export default function IntegracaoExternaGridRow({ integration, onClick }: IntegracaoExternaGridRowProps) {
  return (
    <tr onClick={onClick} style={{ cursor: 'pointer' }}>
      <td>
        <Badge bg="secondary">{integration.tipoLabel || integration.tipo || '—'}</Badge>
      </td>
      <td>{formatDataHora(integration.dataHora)}</td>
      <td>
        {integration.status && (
          <Badge bg={integration.status.variant} className="me-2">{integration.status.label}</Badge>
        )}
        {integration.gridSummary}
      </td>
    </tr>
  );
}
